import React from 'react';

export const Features: React.FC = () => {
    const features = [
        {
            icon: '📡',
            title: 'Monitor 24/7',
            description: 'DLMM pools on Meteora tracked continuously'
        },
        {
            icon: '🎯',
            title: 'Smart Filtering',
            description: 'Custom rules or AI-generated strategies'
        },
        {
            icon: '⚡',
            title: 'Instant Alerts',
            description: 'Flash stake automatically when conditions meet'
        },
        {
            icon: '💎',
            title: 'Track Rewards',
            description: 'Monitor opportunities while you sleep'
        }
    ];

    return (
        <section id="features" className="py-24 bg-black">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block px-6 py-3 bg-purple-500/10 border border-purple-500/30 rounded-full text-purple-300 text-lg font-semibold mb-4">
                        🔮 What is NyxBot?
                    </span>
                    <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
                        An automated Telegram bot built for{' '}
                        <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            Solana LP hunters
                        </span>
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="p-6 bg-gradient-to-b from-purple-500/10 to-transparent border border-purple-500/20 rounded-2xl hover:border-purple-500/40 transition-all"
                        >
                            <div className="text-4xl mb-4">{feature.icon}</div>
                            <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
                            <p className="text-gray-400">{feature.description}</p>
                        </div>
                    ))}
                </div>

                <div className="text-center">
                    <p className="text-xl text-purple-300 font-medium">
                        Stop manually scanning pools. Let the goddess of night do it for you.
                    </p>
                </div>
            </div>
        </section>
    );
};